/* eslint-disable */
// @ts-nocheck
import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, SimpleChanges, isDevMode } from '@angular/core'
import { MasterKey } from '../../../models/master-key'

import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { MasterKeyService } from '../../../services/master-key.service'
import { KeywayService } from '../../../services/keyway-api/keyway.service'
import { KeyNodeType, Keyway, KeywayType, ConstructionKeyType } from '@overtur-monorepo/keying-shared'

@Component({
    selector: 'lib-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    standalone: false
})
export class MenuItemComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  keyNodeType = KeyNodeType
  constructionKeyType = ConstructionKeyType

  @Input() hierarchyItem: MasterKey
  @Input() structure
  @Input() keySystem
  @Input() crossKeyHierarchy = false
  @Input() ownOperatingKey = false
  @Input() isResidentialSystem = false
  @Input() budgetHierarchy = false
  @Input() lastChild = true
  @Input() showChangeKeys = true
  @Input() keyways: Keyway[] = []

  @Output() selectKey = new EventEmitter<MasterKey>()
  @Output() deleteItemAction = new EventEmitter<MasterKey>()
  @Output() patchItemAction = new EventEmitter<any>()
  @Output() addChildAction = new EventEmitter<MasterKey>()

  childKeySections: Keyway[] = []
  thruNode: MasterKey

  isDevModeFn = isDevMode

  constructor(private masterKeyService: MasterKeyService, private keywayService: KeywayService) {}

  ngOnInit() {
    if (this.crossKeyHierarchy && this.hierarchyItem.checked) {
      this.makeParentIndeterminate(this.hierarchyItem)
      // if (this.hierarchyItem.isMasterOperator) {
      //   this.isExpanded = false;
      // }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.hierarchyItem.keyway = this.keyways.filter((keyway) => keyway.id === this.hierarchyItem.keywayId)[0]

    if (this.hierarchyItem.notes.length) {
      this.hierarchyItem.note = this.hierarchyItem.notes.reverse()[0]['message']
    }
  }

  selectIncludedParent(masterKey: MasterKey) {
    this.selectKey.emit(masterKey)
  }

  disableExpand() {
    const noChildren = !this.hierarchyItem.children || this.hierarchyItem.children.length === 0
    return this.hierarchyItem.isMasterOperator || noChildren
  }

  hasChildren(hierarchyItem: MasterKey) {
    return hierarchyItem?.children.some((child) => child.masterKeyTypeId === this.keyNodeType.Master)
  }

  descriptionChanged(updateMasterKeys = false) {}

  addChild(data): void {
    this.addChildAction.emit(data)
  }

  patchItem(patchData) {
    this.patchItemAction.emit(patchData)
  }

  deleteItem(hierarchyItem): void {
    this.deleteItemAction.emit(hierarchyItem)
  }

  toggleCrossKeySelection(val: boolean): void {
    if (val) {
      this.masterKeyService.selectMasterKey(this.hierarchyItem)
      this.makeParentIndeterminate(this.hierarchyItem)
    } else {
      this.hierarchyItem.isMasterOperator = false
      this.hierarchyItem.directChangesOperate = false
      this.removeMasterOperator(this.hierarchyItem)
      this.masterKeyService.deSelectMasterKey(this.hierarchyItem)
    }
  }

  makeParentIndeterminate(master: MasterKey) {
    if (!master.parent || master.parent.directChangesOperate) {
      return
    }
    master.parent.indeterminateCheckBox = true
    master.parent.disabledCheckBox = true
    this.makeParentIndeterminate(master.parent)
  }

  undoParentIndeterminate(master: MasterKey) {
    if (!master.parent) {
      return
    }
    let canMakeIndeterminate = true
    // parent must remain indeterminate if any of its children
    for (const child of master.parent.children) {
      if (child.checked) {
        canMakeIndeterminate = false
        break
      }
    }
    if (!canMakeIndeterminate) {
      return
    }
    master.parent.indeterminateCheckBox = false
    master.parent.disabledCheckBox = false
    this.undoParentIndeterminate(master.parent)
  }

  toggleMasterOperator(): void {
    this.hierarchyItem.isMasterOperator ? this.removeMasterOperator(this.hierarchyItem) : this.makeMasterOperator()
  }

  makeMasterOperator(): void {
    this.hierarchyItem.isMasterOperator = true
    this.hierarchyItem.indeterminateCheckBox = false
    if (this.hierarchyItem.directChangesOperate) {
      this.removeDirectChangesOperate()
    }
    this.makeParentIndeterminate(this.hierarchyItem)
    // this.isExpanded = false;

    // // if not already checked, check the item and add to list in service
    if (!this.hierarchyItem.checked) {
      this.hierarchyItem.checked = true
      this.masterKeyService.selectMasterKey(this.hierarchyItem)
    }
    // // children are implicit - they are collapsed but need to uncheck them if they had previously selected
    for (const child of this.hierarchyItem.children) {
      if (child.isMasterOperator) {
        this.removeMasterOperator(child)
      }
      if (child.checked) {
        this.masterKeyService.deSelectMasterKey(child)
      }
    }
  }

  removeMasterOperator(item: MasterKey): void {
    item.isMasterOperator = false
    this.undoParentIndeterminate(item)
    item.children.forEach((child) => {
      child.disabledCheckBox = false
    })
  }

  toggleDirectChangesOperate(): void {
    this.hierarchyItem.directChangesOperate ? this.removeDirectChangesOperate() : this.applyDirectChangesOperate()
  }

  applyDirectChangesOperate(): void {
    this.hierarchyItem.directChangesOperate = true
    this.hierarchyItem.indeterminateCheckBox = false
    this.makeParentIndeterminate(this.hierarchyItem)

    // if not already checked, check the item and add to list in service
    if (!this.hierarchyItem.checked) {
      this.hierarchyItem.checked = true
      this.masterKeyService.selectMasterKey(this.hierarchyItem)
    }

    const changeKeys = this.hierarchyItem.children.filter((c) => c.isChangeKey)
    for (const changeKey of changeKeys) {
      changeKey.checked = true
      changeKey.disabledCheckBox = true
    }
  }

  removeDirectChangesOperate(): void {
    this.hierarchyItem.directChangesOperate = false
    this.hierarchyItem.indeterminateCheckBox = false
    this.undoParentIndeterminate(this.hierarchyItem)

    const changeKeys = this.hierarchyItem.children.filter((c) => c.isChangeKey)
    for (const changeKey of changeKeys) {
      changeKey.checked = false
      changeKey.disabledCheckBox = false
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  saveKeyway(keyway, hierarchyItem) {
    if (keyway.id && hierarchyItem) {
      this.patchItem({
        type: 'masterKey',
        masterKey: hierarchyItem,
        path: '/keywayId',
        value: keyway.id,
      })
    }
  }

  loadKeyways(hierarchyItem) {
    if (!hierarchyItem.parent) {
      if (this.structure.combinatingRuleSetId === 5) {
        this.childKeySections = this.keyways.filter((kwy) => kwy.keywayTypeId !== KeywayType.Plug)
        this.childKeySections = this.childKeySections.filter((kwy) => kwy.name !== 'C1' && kwy.name !== 'CS')
      } else if (this.structure.combinatingRuleSetId === 8) {
        this.childKeySections = []

        const C1 = this.keyways.find((kwy) => kwy.name === 'C1')
        if (C1) {
          this.childKeySections.push(C1)
        }

        const CS = this.keyways.find((kwy) => kwy.name === 'CS')
        if (CS) {
          this.childKeySections.push(CS)
        }
      } else {
        this.childKeySections = this.keyways.filter((kwy) => kwy.keywayTypeId !== KeywayType.Plug)
      }
    } else {
      const parentKey = hierarchyItem.parent
      const keywayFamilyId = parentKey.keyway.keywayFamilyId
      const keywayId = parentKey.keyway.id
      const masterKeyTypeId = hierarchyItem.masterKeyTypeId
      this.getKeyways(keywayFamilyId, keywayId, masterKeyTypeId)
    }
  }

  getKeyways(keywayFamilyId: number, keywayId: number, masterKeyTypeId: number) {
    this.keywayService
      .getKeyways(keywayFamilyId, keywayId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((keyway: Keyway) => {
        this.childKeySections = []
        if (keyway?.childKeyways) {
          this.childKeySections = keyway?.childKeyways
          this.childKeySections.push(keyway)
          this.childKeySections = this.childKeySections.filter((cks) => cks.keywayTypeId !== KeywayType.Plug)
          this.childKeySections.sort((a, b) => (a.name > b.name ? 1 : -1))
          this.filterKeySectionsForSkdAndDirectChangeMasters(masterKeyTypeId)
        }
      })
  }

  private filterKeySectionsForSkdAndDirectChangeMasters(masterKeyTypeId: number) {
    if (masterKeyTypeId === 5 || masterKeyTypeId === 7) {
      this.childKeySections = this.childKeySections?.filter((kwy) => kwy.keywayTypeId === KeywayType.PlugOrCylinder)
    }
  }

  displayName(keyway) {
    if (!keyway) {
      return
    }
    if (keyway.name) {
      return (keyway && keyway.name) || keyway
    } else if (keyway.description) {
      return (keyway && keyway.description) || keyway
    }
  }
}
